import { Language } from ".";

export enum GameDisplayModeEnum {
  "default" = "default",
  "fullscreen" = "fullscreen",
}

export type GameSettingsType = {
  language: Language;
  walkSpeed: number;
  talkSpeed: number;
  displayMode: GameDisplayModeEnum;
  playMusic: boolean;
  playSounds: boolean;
};
